import Badge from '@adsk/alloy-react-badge';
import { ComponentProps } from 'react';

const BADGE_LINE_STYLE = { padding: '0' };

export const StyledBadge = (props: ComponentProps<typeof Badge>) => {
  const { variant, style } = props;
  const styleOverride = variant === Badge.VARIANTS.LINE ? BADGE_LINE_STYLE : style;
  return <Badge {...props} style={styleOverride} />;
};
